/* Cart drawer + cart page: "This order is a gift" with receiver name, sender name and a message.
   Saved as cart attributes: "Gift order", "Gift to", "Gift from", "Gift message", "Gift hide price".
   Staff see them under "Additional details" on the order. No app needed. */
(function () {
  if (window.__nvEx) return; window.__nvEx = true;
  function root() { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); }
  function save(attrs) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
  function q(box, sel) { return box.querySelector(sel); }
  // collect everything in the box and save it in one go (empty value = attribute removed)
  function collect(box) {
    var on = q(box, '[data-nv-gift-cb]').checked;
    if (!on) return { 'Gift order': '', 'Gift to': '', 'Gift from': '', 'Gift message': '', 'Gift hide price': '' };
    var hp = q(box, '[data-nv-gift-hp]');
    return {
      'Gift order': 'Yes',
      'Gift to': q(box, '[data-nv-gift-to]').value.trim().slice(0, 40),
      'Gift from': q(box, '[data-nv-gift-from]').value.trim().slice(0, 40),
      'Gift message': q(box, '[data-nv-gift-msg]').value.slice(0, 250),
      'Gift hide price': hp && hp.checked ? 'Yes' : ''
    };
  }
  var timers = new WeakMap();
  function saveSoon(box, ms) {
    clearTimeout(timers.get(box));
    timers.set(box, setTimeout(function () { save(collect(box)); }, ms));
  }
  function count(box) {
    var n = q(box, '[data-nv-gift-n]'); if (n) n.textContent = q(box, '[data-nv-gift-msg]').value.length;
  }
  function boxOf(el) { return el.closest && el.closest('[data-nv-gift]'); }

  // the cart's own code treats every 'change' event inside its form as a quantity edit: keep ours away from it
  document.addEventListener('change', function (e) { if (boxOf(e.target)) e.stopPropagation(); }, true);

  // pressing Enter in a gift field must not submit the cart form (= go to checkout)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.nv-gift__in') && boxOf(e.target)) e.preventDefault();
  }, true);

  // turn the gift option on / off, or tick "hide prices"
  document.addEventListener('change', function (e) {
    var box = boxOf(e.target); if (!box) return;
    var cb = e.target.closest('[data-nv-gift-cb]');
    if (cb) {
      var body = q(box, '[data-nv-gift-body]');
      box.classList.toggle('is-on', cb.checked);
      body.hidden = !cb.checked;
      if (!cb.checked) {
        box.querySelectorAll('.nv-gift__in, .nv-gift__msg').forEach(function (f) { f.value = ''; });
        var hp = q(box, '[data-nv-gift-hp]'); if (hp) hp.checked = false;
        count(box);
      } else { var to = q(box, '[data-nv-gift-to]'); if (to) to.focus({ preventScroll: false }); }
      clearTimeout(timers.get(box)); save(collect(box));
    } else if (e.target.matches('[data-nv-gift-hp]')) {
      clearTimeout(timers.get(box)); save(collect(box));
    }
  }, true);

  // typing in names / message
  document.addEventListener('input', function (e) {
    var box = boxOf(e.target); if (!box) return;
    if (e.target.matches('.nv-gift__in, .nv-gift__msg')) {
      e.stopPropagation();
      if (e.target.matches('.nv-gift__msg')) count(box);
      saveSoon(box, 600);
    }
  }, true);

  // quick message chips
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-nv-gift-chip]');
    if (!chip) return;
    var box = boxOf(chip); if (!box) return;
    e.preventDefault();
    var msg = q(box, '[data-nv-gift-msg]');
    msg.value = chip.getAttribute('data-nv-gift-chip').slice(0, 250);
    count(box);
    box.querySelectorAll('.nv-gift__chip').forEach(function (c) { c.classList.toggle('is-sel', c === chip); });
    clearTimeout(timers.get(box)); save(collect(box));
  }, true);
})();
